const commonFunction = {
  buildLocationText: buildLocationText,
  findGenealogyNode: findGenealogyNode,
  listToTree: listToTree,
  findChildNode: findChildNode,
};

export default commonFunction;

function buildLocationText(locationId: string | number, allLocations: Array<any>): string {
  let result = '';
  const selectedLocation = allLocations.find((item) => item.id === locationId);
  if (!selectedLocation) {
    return '--';
  }
  const genealogyNode = findGenealogyNode({ children: listToTree(allLocations) }, locationId)?.children[0];
  const listNode: any[] = [];
  findChildNode(genealogyNode, listNode);
  listNode.reverse();
  result = genealogyNode && genealogyNode?.['isHidden'] ? '***' : genealogyNode?.['name'] || '';
  if (listNode.length > 0) {
    listNode.forEach((item) => {
      if (item.isHidden) {
        result += ' > ***';
      } else {
        result += ` > ${item.name}`;
      }
    });
  }
  if (genealogyNode && genealogyNode.id !== selectedLocation.id) {
    result += selectedLocation.isHidden ? ' > ***' : ` > ${selectedLocation.name}`;
  }

  return result;
}

function findGenealogyNode({ children = [], ...object }: any, nodeId: any) {
  let result;
  if (object?.id === nodeId) return object;
  return (
    children.some((o: any) => (result = findGenealogyNode(o, nodeId))) &&
    Object.assign({}, object, { children: [result] })
  );
}

function listToTree(list: any, idIsGuid = true) {
  if (!list.length) return [];

  const map: any = {};
  let node,
    roots = [],
    i;
  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i; // initialize the map
    list[i].children = []; // initialize the children
  }
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (idIsGuid) {
      if (node.parentId !== '00000000-0000-0000-0000-000000000000') {
        // if you have dangling branches check that map[node.parentId] exists
        if (list[map[node.parentId]]) {
          list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      } else {
        roots.push(node);
      }
    } else {
      if (node.parentId !== 0) {
        // if you have dangling branches check that map[node.parentId] exists
        if (list[map[node.parentId]]) {
          list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      } else {
        roots.push(node);
      }
    }
  }
  return roots;
}

function findChildNode(node: { children: string | any[] } | null | undefined, result: any[]) {
  if (node === undefined || node === null) return;

  if (node && node.children && node.children.length > 0) {
    for (let i = 0; i < node.children.length; i++) {
      if (node.children[i].children && node.children.length > 0) {
        findChildNode(node.children[i], result);
        result.push(node.children[i]);
      }
    }
  }
}
